import StudentUnitQuizResult from './model';
import create from './create';

StudentUnitQuizResult.create = create;

export default StudentUnitQuizResult;



// WEBPACK FOOTER //
// ./data/UnitQuiz/model/index.js